<template>
  <div>
    <v-dialog v-model="dialogOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-text>
          <template v-if="dialogOpen">
            <BroadcastView
              v-if="selectedViewBroadcast"
              :value="selectedViewBroadcast"
              @onClose="$emit('onClose')"
            ></BroadcastView>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BroadcastView from '@/components/view/broadcast/BroadcastView'

export default {
  components: {
    BroadcastView
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    selectedViewItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogOpen: false,
      selectedViewBroadcast: undefined
    }
  },
  watch: {
    open(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dialogOpen = this.open
      }
    },
    selectedViewItem: {
      deep: true,
      handler() {
        this.selectedViewBroadcast = this.selectedViewItem
      }
    }
  },
  mounted() {
    this.selectedViewBroadcast = this.selectedViewItem
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/features/tcp/Broadcast/BroadcastViewDialog.vue